var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrganize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29,11.71L2.59,7,7.29,2.29l1.41,1.41-2.29,2.29h13.59v2H6.41l2.29,2.29-1.41,1.41Zm9.41,.59l-1.41,1.41,2.29,2.29H4v2h13.59l-2.29,2.29,1.41,1.41,4.71-4.71-4.71-4.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganize);
export default __webpack_public_path__ + "static/1787897133/media/icon-organize.d3b23a2e96434621b97c825398a5b8e5.svg";
export { ForwardRef as ReactComponent };